import { ErrorOperation } from "./ErrorOperation";
import { StringOperation } from "./StringOperation";

export abstract class ConvertService
{
    repair: boolean = false;
    private mandatory: boolean;
    constructor(mandatory: boolean = false)
    {
        this.mandatory = mandatory;
    }
    abstract getNullString(): string | null;
    private checkMandatory<D>(value: D): D
    {
        if (!process.env.NAMIRASOFT_MUTE)
            if (this.mandatory)
                if (value == null || value == undefined)
                    this.onMandatoryError();
        return value;
    }
    protected onMandatoryError(): void
    {
        if (!process.env.NAMIRASOFT_MUTE)
            ErrorOperation.throwHTTP(500, "Object value can not be converted.");
    }
    getString(_default: string = ""): string
    {
        let ans = this.checkMandatory(this.getNullString()) ?? _default;
        if (this.repair)
            ans = StringOperation.repair(ans);
        return ans;
    }
    getNullInt(): number | null
    {
        let str = this.getString();
        if (str == null)
            return null;
        let ans = parseInt(str);
        if (isNaN(ans))
            return null;
        return ans;
    }
    getInt(_default: number = 0): number
    {
        return this.checkMandatory(this.getNullInt()) ?? _default;
    }
    getNullFloat(): number | null
    {
        let str = this.getString();
        if (str == null)
            return null;
        let ans = parseFloat(str);
        if (isNaN(ans))
            return null;
        return ans;
    }
    getFloat(_default: number = 0): number
    {
        return this.checkMandatory(this.getNullFloat()) ?? _default;
    }
    getNullDate(): Date | null
    {
        let str = this.getString();
        if (str == null)
            return null;
        let ans = new Date(str);
        if (isNaN(ans.getDate()))
            return null;
        return ans;
    }
    getDate(_default: Date): Date
    {
        return this.checkMandatory(this.getNullDate()) ?? _default;
    }
    getNullBoolean(): boolean | null
    {
        let str = this.getString();
        if (str == null)
            return null;
        let ans = str.toLowerCase();
        if (ans == "true")
            return true;
        if (ans == "false")
            return false;
        return null;
    }
    getBoolean(_default: boolean = false): boolean
    {
        return this.checkMandatory(this.getNullBoolean()) ?? _default;
    }
    getNullEnum<T>(enumObj: { [s: string]: T }): T | null
    {
        let str = this.getString();
        return Object.values(enumObj).find((enumValue) => enumValue === str) as T | null;
    }
    getEnum<T>(enumObj: { [s: string]: T }, _default: T): T
    {
        return this.checkMandatory(this.getNullEnum<T>(enumObj)) ?? _default;
    }
    getStringArray(delimiter: string = ","): string[]
    {
        let ans: string[] = this.getString("").split(delimiter);
        ans = ans.map(v => `${v}`);
        ans = ans.filter(x => x);
        return ans;
    }
    getIntArray(delimiter: string = ","): number[]
    {
        return this.getStringArray(delimiter).map(x => parseInt(x)).filter(x => !isNaN(x));
    }
    getFloatArray(delimiter: string = ","): number[]
    {
        return this.getStringArray(delimiter).map(x => parseFloat(x)).filter(x => !isNaN(x));
    }
    getDateArray(delimiter: string = ","): Date[]
    {
        return this.getStringArray(delimiter).map(x => new Date(x)).filter(x => !isNaN(x.getDate()));
    }
}